import styles from "../styles/Master.module.scss";
function MasterPageButton(props) {
    return (
        <button onClick={() => {
            props.onClick()
        }} autoFocus={props.activePage === "gallery" ? true : false} className={props.activePage ?
            "active-master-button" :
            "d-flex flex-column align-items-center"}>
            <div className={styles.color_around}>{props.icon}</div>
            <span className={styles.description_around}>{props.title}</span>
        </button>
    )
}
export default MasterPageButton;